<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="rooomType">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            房间价格
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="danger" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入房间类型名称" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="roomTypeCode" placeholder="选择房间类型" style="margin:0 10px;" clearable>
                            <el-option
                                    v-for="item in roomTypeValue"
                                    :key="item.roomTypeCode"
                                    :label="item.name"
                                    :value="item.roomTypeCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="calculationType" placeholder="选择计算类型" style="margin:0 10px;" clearable>
                            <el-option
                                    v-for="item in calculationTypeValue"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="name" label="名称"></el-table-column>

                        <el-table-column prop="num" :formatter="roomTypeTitle" label="几人间"></el-table-column>

                        <el-table-column prop="calculationType" label="计算类型"></el-table-column>

                        <el-table-column prop="price" label="价格(元)"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd"  v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit"  v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                tableData:null,
                roomTypeCode:'',
                calculationType:'',
                name:'',
                row:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                roomTypeValue:null,
                calculationTypeValue:[{
                    value:"",
                    label:'全部'
                },{
                    value:"天",
                    label:'天'
                },{
                    value:"周",
                    label:'周'
                },{
                    value:"月",
                    label:'月'
                },{
                    value:"年",
                    label:'年'
                }],
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.init();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
             init:function(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomType/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.roomTypeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row,this.roomTypeValue);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(this.roomTypeValue);
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomTypePrice/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        roomTypeCode:this.roomTypeCode,
                        calculationType:this.calculationType,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
             roomTypeTitle(row){
                return row.num+' 人间'
            },
             rowClick(row){
                this.row=row
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
            }


        }
    }
</script>

<style lang="scss" scoped>
    .rooomType /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
    .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
